import type { ComponentRef, EditorSDK } from '@wix/platform-editor-sdk';

import { ALL_MEMBERS_APP_DEF_ID, APP_TOKEN, PROFILE_WIDGET_APP } from '../../constants';
import { maybeDeleteSOSPContainer } from '../../membersLogic';
import { getComponentData, getComponentType, removeComponentsByAppDefIds } from '../../wrappers/components';
import { getAllMasterControllers } from '../../wrappers/controllers';
import { getMembersAreaMenus, removeItemsFromMenus } from '../../wrappers/menus';
import { remove as removePagesGroup } from '../../wrappers/pagesGroup';
import { removeAllRouters, removeConnectedPages } from '../../wrappers/routers';

async function getIsLoginBarCompRef(editorSDK: EditorSDK, componentRef: ComponentRef) {
  const componentType = await getComponentType({ editorSDK, componentRef });
  return componentType === 'wysiwyg.viewer.components.LoginSocialBar';
}

async function getIsLoginBarController(editorSDK: EditorSDK, controllerRef: ComponentRef) {
  // @ts-expect-error - bad returned value type
  const { controllerType } = await getComponentData({
    editorSDK,
    componentRef: controllerRef,
  });

  return controllerType === 'members-login-bar';
}

async function removeComponents(editorSDK: EditorSDK, controllerRef: { controllerRef: ComponentRef }) {
  const componentsRefs = await editorSDK.controllers.listConnectedComponents(APP_TOKEN, controllerRef);
  for (const componentRef of componentsRefs) {
    if (await getIsLoginBarCompRef(editorSDK, componentRef)) {
      continue;
    }

    await editorSDK.components.remove(APP_TOKEN, { componentRef });
  }
}

async function removeController(editorSDK: EditorSDK, { controllerRef }: { controllerRef: ComponentRef }) {
  if (await getIsLoginBarController(editorSDK, controllerRef)) {
    return;
  }

  await editorSDK.components.remove(APP_TOKEN, { componentRef: controllerRef });
}

async function clearMenuItems(editorSDK: EditorSDK) {
  const maMenus = await getMembersAreaMenus(editorSDK);
  return removeItemsFromMenus(editorSDK, maMenus);
}

async function wipeOut(editorSDK: EditorSDK) {
  const controllersRefs = await getAllMasterControllers(editorSDK);

  for (const controllerRef of controllersRefs) {
    await removeComponents(editorSDK, controllerRef);
    await removeController(editorSDK, controllerRef);
  }

  const appDefIdsToRemove = [PROFILE_WIDGET_APP.appDefinitionId, ALL_MEMBERS_APP_DEF_ID];
  await removeComponentsByAppDefIds(editorSDK, appDefIdsToRemove);
}

export async function clearMembersAreaV1(editorSDK: EditorSDK) {
  await maybeDeleteSOSPContainer(editorSDK);
  await removePagesGroup(editorSDK);
  await removeConnectedPages(editorSDK);
  await removeAllRouters(editorSDK);
  await wipeOut(editorSDK);
  await clearMenuItems(editorSDK);
}
